import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { ErrorHandler } from '@playbookux/playbook-web-core';
import Froala from '../../../../components/froala';
import { processVideoUrls } from '../../../../components/froala/utils';

import {
  Container,
  Loader,
  ReportTitle,
} from './styles';

const NO_REPORT = 'No one on your team has created a report for this project';

function ReportViewUI(props) {
  const {
    error,
    loading,
    name,
    reportData,
    testSessionNotes,
    highlightReels,
    borderless,
  } = props;

  const updatedReportData = useMemo(() => {
    if (error || loading) return null;
    return processVideoUrls(reportData, testSessionNotes, highlightReels);
  }, [error, loading, reportData, testSessionNotes, highlightReels]);

  if (error) {
    return (
      <ErrorHandler
        error={error}
        defaultMessage="Error loading reports. Please check your internet connection."
      />
    );
  }

  if (loading) {
    return (
      <Container borderless={borderless}>
        <Loader data-loader="report-view-loader" />
      </Container>
    );
  }

  return (
    <Container borderless={borderless}>
      <ReportTitle>
        {name}
      </ReportTitle>
      <Froala
        reportData={updatedReportData}
        readOnly
      />
    </Container>
  );
}

ReportViewUI.propTypes = {
  name: PropTypes.string,
  reportData: PropTypes.string,
  testSessionNotes: PropTypes.array,
  highlightReels: PropTypes.array,
  error: PropTypes.object,
  loading: PropTypes.bool,
  borderless: PropTypes.bool,
};

ReportViewUI.defaultProps = {
  name: 'Untitled Report',
  reportData: NO_REPORT,
  testSessionNotes: [],
  highlightReels: [],
  error: undefined,
  loading: false,
  borderless: false,
};

export default ReportViewUI;
